(() => {
  'use strict';
  function previewURL(href) {
    const url = new URL(href, location.origin);
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (url.origin === location.origin && preview) url.searchParams.set('preview_theme_id', preview);
    return url.origin === location.origin ? url.pathname + url.search + url.hash : url.href;
  }
  function init() {
    document.querySelectorAll('[data-xz-preview-link]').forEach(link => { link.href = previewURL(link.getAttribute('href')); });
    document.querySelectorAll('[data-xz-bench]').forEach(bench => {
      if (bench.dataset.ready) return;
      bench.dataset.ready = 'true';
      bench.querySelectorAll('[data-xz-pin]').forEach(pin => pin.addEventListener('click', () => {
        bench.querySelectorAll('[data-xz-pin]').forEach(button => {
          const active = button.dataset.xzPin === pin.dataset.xzPin;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        bench.querySelectorAll('[data-xz-panel]').forEach(panel => { panel.hidden = panel.dataset.xzPanel !== pin.dataset.xzPin; });
      }));
    });
    document.querySelectorAll('[data-xz-learning]').forEach(hub => {
      if (hub.dataset.ready) return;
      hub.dataset.ready = 'true';
      const select = hub.querySelector('[data-xz-learn-select]');
      const link = hub.querySelector('[data-xz-learn-link]');
      const type = hub.querySelector('[data-xz-learn-type]');
      let groups = [...select.querySelectorAll('optgroup')].map(group => group.cloneNode(true));
      const update = () => {
        if (select.value) link.href = previewURL(select.value);
        const label = hub.querySelector('[data-xz-learn-link-label]');
        const note = hub.querySelector('[data-xz-learn-note]');
        link.hidden = !select.value;
        select.disabled = !select.options.length;
        if (label) label.textContent = 'Explore guides & support';
        if (note) note.textContent = select.value ? 'Find available tutorials, product details and instructions for your model.' : 'No models are listed in this category yet. Choose another equipment type.';
      };
      const filter = () => {
        const previous = select.value;
        select.replaceChildren(...groups.filter(group => type.value === 'all' || group.dataset.category === type.value).map(group => group.cloneNode(true)));
        if ([...select.options].some(option => option.value === previous)) select.value = previous;
        let count = 0;
        hub.querySelectorAll('[data-xz-learn-card]').forEach(card => { card.hidden = type.value !== 'all' && card.dataset.category !== type.value; if (!card.hidden) count++; });
        hub.querySelector('[data-xz-learn-count]').textContent = `${type.selectedOptions[0].textContent} · ${count} ${count === 1 ? 'model' : 'models'}`;
        update();
      };
      select.addEventListener('change', update);
      hub.addEventListener('xz:catalog-updating', () => {
        select.replaceChildren(...groups.map(group => group.cloneNode(true)));
      });
      hub.addEventListener('xz:catalog-updated', () => {
        groups = [...select.querySelectorAll('optgroup')].map(group => group.cloneNode(true));
        filter();
      });
      if (type) { type.addEventListener('change', filter); filter(); } else update();
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', init);
})();
